export default __webpack_public_path__ + "static/starry-night-1920-22f7bf6ef0389cde3424d8349ff9fcac.jpg";